import { Schema, SchemaOf } from '@zazume/zzm-utils';
import { mixed } from 'nyup';
import { TFunction } from '#hooks/useI18n';
import { toFormValidation } from '#/utils/formValidation/toFormValidation';
import { FormValidation } from '@zazume/zzm-base';
import { DocumentTypes, DocumentType } from '#/models';

export type CreateDocumentUploadLinkForm = {
  type: DocumentType;
  description?: string;
  expiresAt: Date;
  withMetadataModelUpdate?: boolean;
  withMultipleUploads?: boolean;
}

const schema = (t: TFunction): SchemaOf<CreateDocumentUploadLinkForm> => {
  const requiredMessage = t('general.forms.mandatory');
  return Schema.isObject({
    type: mixed<DocumentType>().oneOf(DocumentTypes, requiredMessage).required(requiredMessage),
    description: Schema.isString().optional(),
    expiresAt: Schema.isDate().required(requiredMessage),
    withMetadataModelUpdate: Schema.isBoolean().optional(),
    withMultipleUploads: Schema.isBoolean().optional()
  });
};

export const getCreateDocumentUploadLinkSchema = (t: TFunction): FormValidation =>
  toFormValidation(t, schema(t));
